import { render, staticRenderFns } from "./IndustriesAddNew.vue?vue&type=template&id=e44c142c&"
import script from "./IndustriesAddNew.vue?vue&type=script&lang=js&"
export * from "./IndustriesAddNew.vue?vue&type=script&lang=js&"
import style0 from "./IndustriesAddNew.vue?vue&type=style&index=0&id=e44c142c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports